import { useState, useEffect, useCallback } from 'react';
import { getReplacedString } from '../../../../../../../helpers/getReplacedString';

const filterBySearchCb = (search) => (item) => {
  const replacedName = getReplacedString(item.name);
  const replacedValue = getReplacedString(search.trim());

  return replacedName.includes(replacedValue);
};

export const useFilterAttachmentsBySearch = ({ attachments }) => {
  const [search, setSearch] = useState('');
  const [filteredAttachments, setFilteredAttachments] = useState(attachments);

  useEffect(() => {
    let timeoutId = null;

    if (search.trim()) {
      timeoutId = setTimeout(() => {
        const newAttachments = attachments?.filter(filterBySearchCb(search));
        setFilteredAttachments(newAttachments || []);
      }, 1000);
    } else {
      setFilteredAttachments(attachments || []);
    }

    return () => clearTimeout(timeoutId);
  }, [JSON.stringify(attachments), search]);

  const onSearchChange = useCallback((e) => setSearch(e.target.value), []);

  return { search, filteredAttachments, onSearchChange };
};
